/* ============================================================================
 * SYLONI® · PDP Enhancement Auto-Injector (Batch 2)
 *
 * 检测 PDP 页面，把 SYLONI 增强 snippet 自动插入 Horizon product.json blocks 之后。
 * 无需修改 Horizon 任何文件。
 *
 * Usage: 自动运行。如需禁用，添加 <body data-syloni-pdp-disable>。
 *
 * Last update: 2026-04-27 · Batch 2 v1.0.0
 * ============================================================================ */

(function () {
  'use strict';

  if (document.body.dataset.syloniPdpDisable !== undefined) return;

  // Detect PDP via URL or Shopify product object
  const isPDP =
    /\/products\//.test(window.location.pathname) ||
    document.body.classList.contains('template-product');

  if (!isPDP) return;

  function findInjectTarget() {
    return (
      document.querySelector('[data-syloni-pdp-anchor]') ||
      document.querySelector('.product-information') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('main')
    );
  }

  function inject() {
    const target = findInjectTarget();
    if (!target) return;
    if (target.dataset.syloniPdpInjected) return;
    target.dataset.syloniPdpInjected = '1';

    // Hooks: pages that should render SYLONI snippets
    // The actual snippet rendering happens server-side via Liquid in product.json blocks.
    // This JS just notifies analytics/scroll behavior.

    if (window.SYLONI) {
      window.SYLONI.modules.pdpEnhance = {
        version: '1.0.0',
        anchor: target,
        productId: window.ShopifyAnalytics ? window.ShopifyAnalytics.meta.product : null,
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  document.addEventListener('shopify:section:load', inject);

  console.log(
    '%c SYLONI pdp-enhance v1.0.0 ',
    'background:#D4AF37;color:#0A0A0A;padding:3px 8px;font-family:monospace;letter-spacing:2px;font-weight:600;'
  );
})();
